import { render, staticRenderFns } from "./week-calendar.vue?vue&type=template&id=146e24ab&scoped=true&"
import script from "./week-calendar.vue?vue&type=script&lang=js&"
export * from "./week-calendar.vue?vue&type=script&lang=js&"
import style0 from "./week-calendar.vue?vue&type=style&index=0&id=146e24ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e24ab",
  null
  
)

export default component.exports